import { useClassified } from "@/contexts/classified";
import { featureFlagsTracking } from "@/contexts/CdpProvider";
import { useTrackingEvent } from "./useTrackingEvent";
export const useTrackingShareProfile = () => {
    var _a, _b;
    const { av_distribution_type_global, av_estate_type_global } = (_b = (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.tracking) !== null && _b !== void 0 ? _b : {};
    const EVENT_DATA = {
        event: "share_classified",
        av_distribution_type_global,
        av_estate_type_global,
        av_ab_test_variant: featureFlagsTracking,
    };
    const thorEvent = useTrackingEvent(EVENT_DATA);
    return () => thorEvent();
};
